import { IFormBuilderAssistant } from '../../../shared/components/form-builder/form-builder-assistant/iform-builder-assistant.interface';
import { FormField } from '../../../shared/models/form-builder/form-field.model';
import { FieldDefinition } from '../../../shared/models/form-builder/field-definition.model';
import { FieldDefinitionService } from '../../../shared/services/field-definition.service';
import { HideFromFieldType, RawHTMLFieldType, ShowToFieldType, UserRolesFieldType } from '../../../shared/models/form-builder/form-field-types';

// Implement a class that implements form builder interface IFormBuilderAssistant.
export class SiteHomePageDesign_FormBuilderAssistant implements IFormBuilderAssistant {
    public get initiallyExpandedFieldGroup(): string {
        return 'Guidance Fields';
    }
    public get titleCanBeConfigured(): boolean {
        return false;
    }

    public filterConditionalLogicSourceFields(fieldDefinitionService: FieldDefinitionService, formFields: FormField[]): FormField[] {
        let filteredFields: FormField[] = []; // formFields.filter(ff => ff.isMetadataField && (ff.fieldDefinitionClassName == UserRolesFieldType));
        if (formFields != null) {
            for (let index: number = 0; index < formFields.length; index++) {
                let formField: FormField = formFields[index];
                if (formField.isMetadataField) {
                    if (formField.fieldDefinitionClassName == UserRolesFieldType)
                        filteredFields.push(formField);
                } else {
                    let fieldDef: FieldDefinition = fieldDefinitionService.getFieldDefinition(formField.fieldDefinitionClassName);
                    if (fieldDef.customLogicHandler.fieldCanBeUsedInSiteHomePageConditionalLogic(formField))
                        filteredFields.push(formField);
                }

            }
        }
        return filteredFields;
    }

    public canOnlyEditHtmlFields(): boolean {
        return false;
    }
    public canEditField(fieldDefinitionService: FieldDefinitionService, formField: FormField): boolean {
        return true;
    }
    public canEditTemplateProperties(): boolean {// Applies to site home pages as well, so where the term 'Template' is used in a general way.
        return true;
    }

    // Constructor.
    public constructor() { }
}
